import * as React from "react";
import { cn } from "@/lib/utils";

/** Canon `.h` / `.label` / `.eyebrow`: 10.5px, 600, caps, .12em, dim. ONE section/panel header for table and Studio.
 *  Renders a real heading (h3 by default); `as="div"` for decorative eyebrows inside other headings. */
export const SECTION_HEADER_CLASS = "text-label font-semibold uppercase tracking-label text-dim";

/** Canon `.field .k`: the caps label above a form field (lighter than a section header). */
export const FIELD_LABEL_CLASS = "text-meta font-normal uppercase tracking-field text-dim";

type Props = React.HTMLAttributes<HTMLHeadingElement> & { as?: "h2" | "h3" | "h4" | "div" | "span" };

export function SectionHeader({ as = "h3", className, ...props }: Props) {
  const Comp = as as React.ElementType;
  return <Comp className={cn(SECTION_HEADER_CLASS, className)} {...props} />;
}
